import logo_yellow_1x from '@client/shared/styles/assets/logo/logo-yellow.png';
import logo_yellow_2x from '@client/shared/styles/assets/logo/logo-yellow@2x.png';
import logo_black_1x from '@client/shared/styles/assets/logo/logo-black.png';
import logo_black_2x from '@client/shared/styles/assets/logo/logo-black@2x.png';
import logo_blue_1x from '@client/shared/styles/assets/logo/logo-blue.png';
import logo_blue_2x from '@client/shared/styles/assets/logo/logo-blue@2x.png';
import levels from '@client/shared/styles/assets/logo/levels-logo-white-small.png';
export default {
  logo_yellow_1x,
  logo_yellow_2x,
  logo_black_1x,
  logo_black_2x,
  logo_blue_1x,
  logo_blue_2x,
  levels,
};
